import { auth, type SchemaResponse } from "@/modules/api"
import type { Campaign } from "@/modules/types"
import type { PagingSchema } from "@/modules/types/common/schema"

type Filter = {
  sort: string
  est: {
    select: string
    rang: {
      min: number
      max: number
    }
    all: boolean
    over: boolean
  }
}

export const searchCampaign = async ({
  categoryId,
  nextPageToken,
  ...filters
}: {
  search?: string
  categoryId?: string
  nextPageToken?: string
}) => {
  let params: object = filters

  const settingString = await localStorage.getItem("@search-setting")
  if (nextPageToken) {
    params = { ...params, nextPageToken }
  }
  if (categoryId) {
    params = { ...params, categoryIds: `${categoryId}` }
  }
  if (settingString) {
    const settings = JSON.parse(settingString) as Filter
    if (settings) {
      if (!settings.sort || settings.sort === "newest") {
        params = { ...params, order: "DESC" }
      }
      if (settings.sort === "nearest") {
        params = { ...params, order: "ASC" }
      }
      if (settings.est.select === "over") {
        params = {
          ...params,
          pricePerKolFrom: 10000000,
          pricePerKolTo: null
        }
      }
      if (settings.est.select === "all") {
        params = { ...params, pricePerKolFrom: null, pricePerKolTo: null }
      }
      if (settings.est.select === "rang") {
        params = {
          ...params,
          pricePerKolFrom: settings.est.rang.min || 0,
          pricePerKolTo: settings.est.rang.max || 10000000
        }
      }
    }
  }
  return auth.get<SchemaResponse<PagingSchema<Campaign>>>(`v1/campaign/explore`, {
    params
  })
}
